import React, { useState } from "react";
import styled from "styled-components";
import { ButtonLink } from "../../elements/ButtonLink";

export default function Lojinha({ channels }) {
  const [selectedChannel, setSelectedChannel] = useState(channels[0]);
  const [paymentType, setPaymentType] = useState("annual");

  return (
    <Section id="singles">
      <Title>Assinaturas individuais</Title>
      <SubTitleDiv>
        <BenefitsDiv>
          Você também pode contratar seus streamings favoritos pelo UOL Play,
          aproveitar vários conteúdos originais e ainda ter acesso a todos os
          benefícios do Clube UOL.
        </BenefitsDiv>
      </SubTitleDiv>

      <PlansContainer>
        <Tabs>
          {channels.map((channel) => (
            <Tab
              key={channel.id}
              $active={selectedChannel.id === channel.id}
              onClick={() => setSelectedChannel(channel)}
              $borderColor={channel.borderColor}
            >
              <img src={channel.tabImageUrl} alt={channel.id} />
              {channel.id !== selectedChannel.id && (
                <TabInfo>
                  A partir de R$ <p>{channel.annualPrice}</p> /mês
                </TabInfo>
              )}
            </Tab>
          ))}
        </Tabs>

        <Content $borderColor={selectedChannel.borderColor}>
          <Description>
            <div className="content-text">
              <p>{selectedChannel.contentText}</p>
            </div>
            <BannerContainer>
              {selectedChannel.posterList.map((poster) => (
                <img
                  key={poster.imageUrl}
                  className={selectedChannel.id === "NBA" ? "nba" : ""}
                  src={poster?.imageUrl}
                  alt={poster?.altText}
                />
              ))}
            </BannerContainer>
          </Description>

          <PriceBox>
            <AnnualPrice
              $borderColor={
                paymentType === "annual"
                  ? selectedChannel.borderColor
                  : "transparent"
              }
              onClick={() => setPaymentType("annual")}
              $isSelected={paymentType === "annual"}
            >
              <Div>
                <Discount $paymentType={paymentType} $isAnnual={true}>
                  {selectedChannel.discount}% de desconto
                </Discount>
                <RadioWrapper $paymentType={paymentType} $isAnnual={true}>
                  <input
                    type="radio"
                    name="singleAnnual"
                    id="singleAnnual"
                    checked={paymentType === "annual"}
                    onChange={() => setPaymentType("annual")}
                  />
                  <label htmlFor="singleAnnual">{selectedChannel.nameFirstPlanType}</label>
                </RadioWrapper>
              </Div>
              <Div>
                <Price $paymentType={paymentType} $isAnnual={true}>
                  {selectedChannel.installments} de R${" "}
                  <span>{selectedChannel.annualPrice}</span>{" "}
                </Price>
                <TotalPrice>
                  Total R$ {selectedChannel.totalPrice}
                  {selectedChannel.suffixOption}
                </TotalPrice>
                <CinemaOffer $paymentType={paymentType} $isAnnual={true}>
                  <p>
                    <Bold>Ganhe R$ 20</Bold> <br /> na ingresso.com
                  </p>
                </CinemaOffer>
              </Div>
            </AnnualPrice>
            <MonthlyPrice
              $borderColor={
                paymentType === "monthly"
                  ? selectedChannel.borderColor
                  : "transparent"
              }
              onClick={() => setPaymentType("monthly")}
              $isSelected={paymentType === "monthly"}
            >
              <RadioWrapper $paymentType={paymentType} $isAnnual={false}>
                <input
                  type="radio"
                  name="singleMonthly"
                  id="singleMonthly"
                  checked={paymentType === "monthly"}
                  onChange={() => setPaymentType("monthly")}
                />
                <label htmlFor="singleMonthly">
                  {selectedChannel.nameSecondPlanType}
                </label>
              </RadioWrapper>
              <Price $paymentType={paymentType} $isAnnual={false}>
                R$ <span>{selectedChannel.monthlyPrice}</span>/mês
              </Price>
            </MonthlyPrice>
            <ButtonLink
              as="a"
              href={
                paymentType === "annual"
                  ? selectedChannel.annualCtaUrl
                  : selectedChannel.monthlyCtaUrl
              }
              text={
                paymentType === "annual"
                  ? selectedChannel.ctaTextAnnual
                  : selectedChannel.ctaText
              }
              size="pv"
            />
          </PriceBox>
        </Content>
      </PlansContainer>
    </Section>
  );
}

const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0 120px;
  background-color: #202020;
`;

const Title = styled.h4`
  font-size: 32px;
  color: white;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 28px;
    padding: 20px;
    padding-bottom: 40px;
  }
`;

const SubTitleDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 815px;
`;

const Bold = styled.strong`
  font-weight: bold;
  margin-right: 5px;
  font-size: 16px;
  font-weight: 18px;
`;

const BenefitsDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  color: #ffffff;
  margin-top: 15px;
`;

const PlansContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1290px;
  background-color: #202020;
  color: white;
  margin-top: 50px;
`;

const Tabs = styled.div`
  display: flex;
  gap: 10px;
`;

const Tab = styled.div`
  flex: 1;
  width: 250px;
  height: ${(props) => (props.$active ? "130px" : "120px")};
  margin-bottom: ${(props) => (props.$active ? "0" : "10px")};
  padding: 16px;
  text-align: center;
  background-color: ${(props) => (props.$active ? "#393939" : "#292929")};
  color: ${(props) => (props.$active ? "white" : "#727272")};
  font-weight: ${(props) => (props.$active ? "bold" : "regular")};
  text-align: left;
  border: 2px solid
    ${(props) => (props.$active ? props.$borderColor : "transparent")};
  border-bottom: ${(props) => (props.$active ? "none" : "2px solid #393939")};
  z-index: 1;
  position: relative;

  &:hover {
    cursor: pointer;
    border: 2px solid ${(props) => props.$borderColor};
    border-bottom: 2px solid
      ${(props) => (props.$active ? "transparent" : props.$borderColor)};
    z-index: 1;
  }
`;

const TabInfo = styled.div`
  font-size: 0.875rem;
  color: #727272;
  display: flex;
  flex-wrap: no-wrap;
  align-items: center;
  justify-content: flex-start;
  position: absolute;
  bottom: 12px;
  white-space: nowrap;

  p {
    font-size: 20px;
    font-weight: bold;
    margin-left: 5px;
  }
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  background-color: #393939;
  padding: 17px;
  border: 2px solid ${(props) => props.$borderColor || "transparent"};
  margin-top: -2px;
  max-height: 320px;
`;

const PriceBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #222222;
  gap: 16px;
  width: 443px;
  height: 280px;
  padding: 12px;
  border-radius: 4px;
`;

const PlanCard = styled.div`
  border: 2px solid ${(props) => props.$borderColor || "transparent"};
  border-radius: 4px;
  display: flex;
  width: 418px;
  height: 125px;
  flex-direction: row;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.3s;
`;

const AnnualPrice = styled(PlanCard)`
  position: relative;
`;

const MonthlyPrice = styled(PlanCard)`
  justify-content: space-around;
  align-items: center;
`;

const Div = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 20px;
`;

const Discount = styled.div`
  background-color: ${({ $paymentType, $isAnnual }) =>
    $paymentType === "annual" && $isAnnual
      ? "#FF8000"
      : $paymentType === "monthly" && !$isAnnual
      ? "#FF8000"
      : "#1D1D1D"};
  width: 188px;
  color: ${({ $paymentType, $isAnnual }) =>
    $paymentType === "annual" && $isAnnual
      ? "white"
      : $paymentType === "monthly" && !$isAnnual
      ? "white"
      : "#727272"};
  padding: 5px 10px 5px 23px;
  font-size: 16px;
  font-weight: bold;
  margin: 10px 0;
  border-radius: 0 20px 20px 0;
`;

const RadioWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 0;

  ${AnnualPrice} & {
    margin-bottom: 50px;
  }

  input {
    cursor: pointer;
    appearance: none;
    border: 3px solid #808080;
    border-radius: 50%;
    outline: none;
    width: 21px;
    height: 21px;
    display: flex;
    align-items: center;
    position: relative;

    &:checked {
      border-color: ${({ $paymentType, $isAnnual }) =>
        $paymentType === "annual" && $isAnnual
          ? "#ff8000"
          : $paymentType === "monthly" && !$isAnnual
          ? "#ff8000"
          : "#727272"};
    }

    &:checked::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 11px;
      height: 11px;
      background-color: ${({ $paymentType, $isAnnual }) =>
        $paymentType === "annual" && $isAnnual
          ? "#ff8000"
          : $paymentType === "monthly" && !$isAnnual
          ? "#ff8000"
          : "#727272"};
      border-radius: 50%;
    }
  }

  label {
    color: ${({ $paymentType, $isAnnual }) =>
      $paymentType === "annual" && $isAnnual
        ? "#fff"
        : $paymentType === "monthly" && !$isAnnual
        ? "#fff"
        : "#727272"};
    cursor: pointer;
    font-size: 16px;
    padding-top: 10px;
    display: flex;
    align-items: center;
  }
`;

const CinemaOffer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 0;
  top: 48%;
  align-items: center;
  background-color: ${({ $paymentType, $isAnnual }) =>
    $paymentType === "annual" && $isAnnual
      ? "#6C04BA"
      : $paymentType === "monthly" && !$isAnnual
      ? "#6C04BA"
      : "#1D1D1D"};
  font-size: 18px;
  color: ${({ $paymentType, $isAnnual }) =>
    $paymentType === "annual" && $isAnnual
      ? "white"
      : $paymentType === "monthly" && !$isAnnual
      ? "white"
      : "#727272"};
  padding: 4px 40px 2px 20px;
  margin: 13px 0;
  border-radius: 20px 0 0 20px;
  p {
    font-size: 16px;
    line-height: 18px;
  }
`;

const Price = styled.div`
  font-size: 16px;

  ${AnnualPrice} & {
    margin-top: -80px;
    margin-left: 40px;
  }

  span {
    font-size: 24px;
    font-weight: bold;
  }

  color: ${({ $paymentType, $isAnnual }) =>
    $paymentType === "annual" && $isAnnual
      ? "white"
      : $paymentType === "monthly" && !$isAnnual
      ? "white"
      : "#727272"};
`;

const TotalPrice = styled.div`
  font-size: 14px;
  color: #999;
  margin-left: 35px;
`;

const Description = styled.div`
  display: flex;
  flex-direction: column;

  .content-text {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  p {
    font-size: 18px;
    margin-bottom: 18px;
    color: white;
    text-align: center;
    padding: 0 32px;
  }
`;

const BannerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;

  .nba {
    width: 790px;
    height: auto;
    background-color: transparent;
  }

  img {
    width: 100px;
    height: 127px;
    background-color: #202020;
    border-radius: 6px;
  }
`;
